// extracted by mini-css-extract-plugin
module.exports = {"actions":"ImageActionsCell2_actions_8FGHK","redCrossImage":"ImageActionsCell2_redCrossImage_1Ag6O"};